import React from "react";
import {
  PaymentCardVisual,
  formatPaymentCardAmount,
} from "./PaymentCardVisual";

type InvestmentPaymentCardProps = {
  cardNumber?: string | null;
  amount?: number | null;
  expiresInfo?: {
    label: string;
    value?: string | Date | null;
  } | null;
  status?: string | null;
  usedAt?: string | Date | null;
  cancelledAt?: string | Date | null;
  fundName?: string | null;
};

export const InvestmentPaymentCard: React.FC<InvestmentPaymentCardProps> = ({
  cardNumber,
  amount,
  expiresInfo,
  status,
  usedAt,
  cancelledAt,
  fundName,
}) => {
  const secondaryDate =
    status === "used" && usedAt
      ? { label: "مصرف", value: usedAt }
      : status === "cancelled" && cancelledAt
        ? { label: "لغو", value: cancelledAt }
        : null;

  return (
    <PaymentCardVisual
      cardNumber={cardNumber}
      primaryDate={expiresInfo}
      secondaryDate={secondaryDate}
      amount={formatPaymentCardAmount(amount)}
      fundName={fundName}
    />
  );
};
